'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dCredit$002dNote from "./app.data.-App-Document-Data-Create-Request$-Credit-Note.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreateRequest$CreditNote$() {
}
export { $c_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ as $c_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ };
$p = $c_Lapp_data_AppDocumentDataCreateRequest$CreditNote$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCreateRequest$CreditNote$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreateRequest$CreditNote$() {
}
export { $h_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ as $h_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ };
$h_Lapp_data_AppDocumentDataCreateRequest$CreditNote$.prototype = $p;
$p.n = (function() {
  return "CreditNote";
});
$p.bKd = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dCredit$002dNote.$c_Lapp_data_AppDocumentDataCreateRequest$CreditNote(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKd(p);
});
var $d_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreateRequest$CreditNote$, "app.data.AppDocumentDataCreateRequest$CreditNote$", ({
  Ao: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ as $d_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ };
var $n_Lapp_data_AppDocumentDataCreateRequest$CreditNote$;
function $m_Lapp_data_AppDocumentDataCreateRequest$CreditNote$() {
  if ((!$n_Lapp_data_AppDocumentDataCreateRequest$CreditNote$)) {
    $n_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ = new $c_Lapp_data_AppDocumentDataCreateRequest$CreditNote$();
  }
  return $n_Lapp_data_AppDocumentDataCreateRequest$CreditNote$;
}
export { $m_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ as $m_Lapp_data_AppDocumentDataCreateRequest$CreditNote$ };
//# sourceMappingURL=app.data.-App-Document-Data-Create-Request$-Credit-Note$.js.map
